import { Condition } from 'types/GlobalKpiOption'
import { TSliceFilterCondition } from 'types/GlobalSlice'
import { translateFilterCondition } from 'utils/enumTranslator'

export const conditionOptions: Record<
  TSliceFilterCondition,
  {
    id: TSliceFilterCondition
    title: string
  }
> = {
  [Condition.EQ]: {
    id: Condition.EQ,
    title: translateFilterCondition[Condition.EQ].textIcon
  },
  [Condition.NE]: {
    id: Condition.NE,
    title: translateFilterCondition[Condition.NE].textIcon
  },
  [Condition.GT]: {
    id: Condition.GT,
    title: translateFilterCondition[Condition.GT].textIcon
  },
  [Condition.LT]: {
    id: Condition.LT,
    title: translateFilterCondition[Condition.LT].textIcon
  },
  [Condition.IS_NOT_NULL]: {
    id: Condition.IS_NOT_NULL,
    title: translateFilterCondition[Condition.IS_NOT_NULL].textIcon
  },
  [Condition.IS_NULL]: {
    id: Condition.IS_NULL,
    title: translateFilterCondition[Condition.IS_NULL].textIcon
  }
}

// conditions for value-list attributes
export const DEFAULT_CONDITIONS: TSliceFilterCondition[] = [
  Condition.EQ,
  Condition.NE,
  Condition.IS_NOT_NULL,
  Condition.IS_NULL
]
